import { Outlet, createFileRoute } from "@tanstack/react-router";

import { requirePermission } from "~/lib/functions/admin-access";

export const Route = createFileRoute("/admin/cih")({
  staticData: { title: "CIH" },
  beforeLoad: ({ context }) =>
    requirePermission(context.adminPermissions, "cih:read"),
  component: () => <Outlet />,
});
